module.exports = __webpack_public_path__ + "img/horizontal-traffic-light.59085ba5.png";